import React from "react";
import ReactDOM from "react-dom";

import { CruzarReferenciasPorGrupoMontajeImpresionEnAPI, CruzarReferenciasPorGrupoMontajeEnAPI, GetCSVEnAPI } from "../../action/actionCreatorsRequests";
import { descargarPdfPasandoBase64, descargarDocPasandoBase64Generico, traducirPagina } from "../../librerias/funciones"
import FichaCruceMarcaVehiculo from "./FichaCruceMarcaVehiculo";
import FichaImpresionGenerico from "../FichaImpresionGenerico";
import {
    PlusOutlined,
    CloseOutlined,
    SearchOutlined,
    EyeOutlined,
    EyeInvisibleOutlined,
    PrinterOutlined
} from '@ant-design/icons';
import CPSearch from "../Utils/CPSearch";
import FichaNuevoCruceMarcas from "./FichaNuevoCruceMarcas";


const MantenimientoGrupoMontaje = ({ }) => {
    const ref = React.useRef(null)
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const [abrirImpresion, setAbrirImpresion] = React.useState(false);
    const [loaderTabla, setLoaderTabla] = React.useState(false);
    const [DOC_HTML, setDOC_HTML] = React.useState("");
    const [reglasAlmacenes, setReglasAlmacenes] = React.useState([]);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);
    const [fichaMarcas, setFichaMarcas] = React.useState(false);

    const [filtroLocal, setFiltroLocal] = React.useState({
        ID_GRUPO_MONTAJE: null,
        TEXTO_BUSCADOR: "",
        LOADER_CSV: false,
        SIN_PRECIO: false
    });



    const buscarDocumento = () => {
        CruzarReferenciasPorGrupoMontajeImpresionEnAPI("HTML", reglasAlmacenes).then((doc) => {
            const { OK, DATA } = doc

            if (OK) {
                if (DATA !== undefined && DATA !== null && DATA !== "") {
                    setDOC_HTML(DATA)
                } else {
                    setDOC_HTML(null)
                }
            }

        })
    }
    const buscarDocumentoPDF = () => {
        CruzarReferenciasPorGrupoMontajeImpresionEnAPI("PDF", reglasAlmacenes).then((doc) => {
            const { OK, DATA } = doc

            if (OK) {
                if (DATA !== undefined && DATA !== null && DATA !== "") {
                    descargarPdfPasandoBase64(DATA)
                }
            }
        })
    }

    const buscarDocumentoCSV = () => {
        CruzarReferenciasPorGrupoMontajeImpresionEnAPI("CSV", reglasAlmacenes).then((doc) => {
            const { OK, DATA } = doc

            if (OK) {
                if (DATA !== undefined && DATA !== null && DATA !== "") {
                    descargarDocPasandoBase64Generico(DATA, "csv")
                }
            }
        })
    }


    const CruzarReferenciasPorGrupoMontaje = async (MARCA_ORIGEN, GRUPO_MONTAJE, MARCAS_DESTINO) => {
        setLoaderTabla(true)
        setReglasAlmacenes([])

        let registros = await CruzarReferenciasPorGrupoMontajeEnAPI(MARCA_ORIGEN, GRUPO_MONTAJE, MARCAS_DESTINO)

        if (registros !== undefined && registros !== null && registros.REGISTROS !== undefined && registros.REGISTROS !== null && registros.REGISTROS.length > 0) {
            setReglasAlmacenes(registros.REGISTROS)
        } else {
            setReglasAlmacenes(null)

        }
        setLoaderTabla(false)

        return registros;
    }




    const filtroLocalDeLaTabla = (textoAFiltrar, registros) => {
        let resultado = []

        if (textoAFiltrar.trim() !== "") {
            if (registros !== null) {

                let resultadoFiltro = registros.filter((item) => {
                    return item.MARCA_ORIGEN.toUpperCase().includes(textoAFiltrar.toUpperCase()) ||
                        item.MARCA_ORIGEN.toUpperCase().includes(textoAFiltrar.toUpperCase())
                })


                if (resultadoFiltro.length > 0) {
                    resultado = resultadoFiltro;
                }
            }
        } else {
            resultado = registros;
        }

        console.log("Previa", resultado)

        return resultado
    }

    const verificarCruce = (ITEM) => {
        let MOSTRAR = true
        if (ITEM === "") {
            MOSTRAR = !filtroLocal.SIN_PRECIO
        }
        return MOSTRAR
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
        setFichaMarcas(true)
    }, [])




    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {traducirPagina("Msg_cruce_referencia_grupo").toUpperCase()}
        </>,
        document.getElementById("tituloMenu")
    );


    return (
        <>
            <div className="menu_mantenimiento" ref={ref}>
                
                <div className="mantenimiento_item1">
                    <div className={`grid-container ${(reglasAlmacenes === undefined || reglasAlmacenes === null || reglasAlmacenes.length === 0) && "bloquearDiv"}`} style={{ backgroundColor: '#fff', padding: '0px' }}>
                        <CPSearch
                            textoBuscador={filtroLocal.TEXTO_BUSCADOR}
                            onChangeInput={(e) => {
                                let txtBuscadorLocal = e.target.value;
                                filtroLocal.TEXTO_BUSCADOR = txtBuscadorLocal;
                                setFiltroLocal({ ...filtroLocal })
                            }}
                            onCloseInput={() => {
                                let txtBuscadorLocal = "";
                                filtroLocal.TEXTO_BUSCADOR = txtBuscadorLocal;
                                setFiltroLocal({ ...filtroLocal })
                            }}
                            styles={{ height: '-webkit-fill-available', border: 'none' }}
                        />

                        <button
                            style={{ backgroundColor: '--azul-claro-serca', color: '#fff' }}
                            className="btn_buscador_tarifa efectoHoverGrupo"
                            onClick={() => { filtroLocal.SIN_PRECIO = !filtroLocal.SIN_PRECIO; setFiltroLocal({ ...filtroLocal }) }}>
                            {filtroLocal.SIN_PRECIO ? <EyeInvisibleOutlined style={{ fontSize: '20px' }} /> : <EyeOutlined style={{ fontSize: '20px' }} />}  {traducirPagina("Sin_cruce")}
                        </button>

                        <button
                            className="btn_buscador_tarifa efectoHoverGrupo"
                            style={{ backgroundColor: '--azul-claro-serca', color: '#fff' }}
                            onClick={() => {
                                setAbrirImpresion(true);
                                buscarDocumento();
                            }}
                        >
                            <PrinterOutlined style={{ fontSize: '20px' }} />
                        </button>

                    </div>
                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => { setFichaMarcas(true) }}>
                        <SearchOutlined /> {traducirPagina("Nueva_consulta")}
                    </div>
                </div>
            </div>


            <div className="margen_tabla">
                {reglasAlmacenes === null ?
                    <div style={{ textAlign: 'center' }}>
                        <h4>{traducirPagina("Sin_registros")}</h4>
                    </div>
                    :

                    reglasAlmacenes.length > 0 ?
                        <div className=" containerDetalleTabla" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )`,margin:'0px',padding:'0px' }}>
                            <table style={{  width: '100%' }}>
                                <thead>
                                    <tr style={{backgroundColor:'var(--azul-claro-serca)',color:'#fff'}}>
                                        <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}> {reglasAlmacenes[0].MARCA_ORIGEN}  </th>
                                        <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].FAMILIA} </th>

                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_1 !== "" &&  verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_1) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].MARCA_DESTINO_1} </th> : null}
                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_1 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_1) ? <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].FAMILIA_1} </th> : null}

                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_2 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_2) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].MARCA_DESTINO_2} </th> : null}
                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_2 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_2) ? <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].FAMILIA_2} </th> : null}

                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_3 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_3) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].MARCA_DESTINO_3} </th> : null}
                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_3 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_3) ? <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].FAMILIA_3} </th> : null}

                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_4 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_4) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].MARCA_DESTINO_4} </th> : null}
                                        {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_4 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_4) ? <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {reglasAlmacenes[0].FAMILIA_4} </th> : null}

                                    </tr>
                                </thead>
                                <tbody>
                                    {filtroLocalDeLaTabla(filtroLocal.TEXTO_BUSCADOR, reglasAlmacenes).map((regla, i) =>
                                        i > 0 ?
                                            <tr key={regla.ID} style={{ backgroundColor: '#fff' }}>
                                                <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' ,backgroundColor:'#dcdcdc'}} >{regla.MARCA_ORIGEN}</td>

                                                <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {regla.FAMILIA} </th>


                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_1 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_1) ? <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left',backgroundColor:'#f2f2f2' }}>{regla.MARCA_DESTINO_1}</td> : null}
                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_1 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_1) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {regla.FAMILIA_1} </th> : null}

                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_2 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_2) ? <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' ,backgroundColor:'#f2f2f2'}}>{regla.MARCA_DESTINO_2}</td> : null}
                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_2 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_2) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left'}}  > {regla.FAMILIA_2} </th> : null}

                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_3 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_3) ? <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left',backgroundColor:'#f2f2f2' }}>{regla.MARCA_DESTINO_3}</td> : null}
                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_3 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_3) ? <th style={{  border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' }}  > {regla.FAMILIA_3} </th> : null}

                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].MARCA_DESTINO_4 !== "" && verificarCruce(reglasAlmacenes[1].MARCA_DESTINO_4) ? <td style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left' ,backgroundColor:'#f2f2f2'}}>{regla.MARCA_DESTINO_4}</td> : null}
                                                {reglasAlmacenes.length > 1 && reglasAlmacenes[0].FAMILIA_4 !== "" && verificarCruce(reglasAlmacenes[1].FAMILIA_4) ? <th style={{ border: '1px solid #d9d9d9', padding: '4px', textAlign: 'left'}}  > {regla.FAMILIA_4} </th> : null}

                                            </tr>
                                            :
                                            null
                                    )
                                    }
                                </tbody>
                            </table>
                        </div>
                        :
                        loaderTabla ?

                            <div className="center_item_mant_grupo" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}> <div className="spinner-border  fast colorSubAzul" role="status" disabled /> </div>
                            :
                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '80vh' }}>
                                <h4>
                                    {traducirPagina("Inicie_busqueda")}

                                </h4>
                            </div>
                }
            </div>

            {
                /*
                  <FichaCruceMarcaVehiculo
                  title={traducirPagina("Msg_cruce_referencia_grupo")}
                  ABRIR_FICHA={fichaMarcas}
                  CERRAR_FICHA={setFichaMarcas}
                  ID_SOCIO={socioSeleccionado}
                  CALCULAR_CRUCE={CruzarReferenciasPorGrupoMontaje}
              >
              </FichaCruceMarcaVehiculo>
              */

            }

            {fichaMarcas ?
                <FichaNuevoCruceMarcas
                    titulo={traducirPagina("Msg_cruce_referencia_grupo")}
                    abrirFicha={fichaMarcas}
                    cerrarFicha={setFichaMarcas}

                    calcularCruce={CruzarReferenciasPorGrupoMontaje}

                >
                </FichaNuevoCruceMarcas>
                :
                null}


            {abrirImpresion ?
                <FichaImpresionGenerico
                    title={traducirPagina("Impresion_doc").toUpperCase()}
                    ABRIR_FICHA={abrirImpresion}
                    CERRAR_FICHA={setAbrirImpresion}

                    DOCUMENTO={DOC_HTML}
                    MODIFICAR_DOCUMENTO={setDOC_HTML}
                    DESCARGAR_DOCUMENTO={buscarDocumentoPDF}
                    DESCARGAR_CSV={buscarDocumentoCSV}
                    VER_CSV={true}

                ></FichaImpresionGenerico>
                :
                null
            }
        </>
    );
}



export default MantenimientoGrupoMontaje;